import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '../materialUi.js';
import { withFormik } from 'formik';
import TextField from "../FormikTextField";
import {Field} from 'formik';
import * as Yup from "yup";
import Button from '@material-ui/core/Button';
import Switches from './Switches';
import { SimpleSnackbar } from '../SimpleSnackbar.js';

var divStyle = {
  margin: "20px"
};

const formikEnhancer = withFormik({
    validationSchema: Yup.object().shape({
        email: Yup.string().email().required('Email requerido'),
        name: Yup.string().required('Nombre requerido'),
    }),

    mapPropsToValues: props => ({
        handleSubmitUpdate: props.handleSubmitUpdate,
        id: props.userData.id,
        roles: props.userData.roles.map( role => role.id ),
        email: props.userData.email,
        name: props.userData.name,
        password: null
    }),

    handleSubmit: (values, { setSubmitting }) => {
        const payload = {
            ...values,
        };
        setTimeout(() => {
            values.handleSubmitUpdate( payload );
            setSubmitting(false);
        }, 1000);
    },
    displayName: 'MyForm',
});

const MyForm = props => {
    const {
        values,
        errors,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        handleClose,
        errorModal,
        rolesOptions,
    } = props;
    const rolCargador = rolesOptions.find( role => role.name === 'CARGAR' );
    return (
        <Dialog
            maxWidth="md"
            open={true}
            onClose={handleClose}
            fullScreen={true}
        >
            {errorModal && <SimpleSnackbar message={errorModal}/>}
            <form onSubmit={handleSubmit}>
                <DialogTitle style={{marginLeft:"7px"}} id="form-dialog-title">Modificar Usuario</DialogTitle>
                <DialogContent>
                    <div className="row">
                        <div width="33%" className="form-group" style={divStyle}>
                            <Field
                                style = {{width: "515px"}}
                                type="email"
                                label="Email"
                                name="email"
                                margin="normal"
                                onChange={setFieldValue}
                                variant="outlined"
                                component={TextField}
                            />
                        </div>
                        <div width="33%" className="form-group" style={divStyle}>
                            <Field
                                style = {{width: "515px"}}
                                type="name"
                                label="Nombre"
                                name="name"
                                margin="normal"
                                onChange={setFieldValue}
                                variant="outlined"
                                component={TextField}
                            />
                        </div>
                        <div width="33%" className="form-group" style={divStyle}>
                            <Field
                                style = {{width: "515px"}}
                                type="password"
                                label="Contraseña"
                                name="password"
                                margin="normal"
                                onChange={setFieldValue}
                                variant="outlined"
                                component={TextField}
                            />
                        </div>
                    </div>
                    <div className="col">
                        <h5 style={divStyle}>Asignar roles</h5>
                        <Switches
                            roles={rolesOptions}
                            value={values.roles}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                            error={errors.roles}
                            cargadorId={rolCargador ? rolCargador.id : -1}
                        />
                    </div>
                    <div className="row" style={{marginLeft:"-5px"}} >
                        <Button variant="contained" type="submit" style={{margin:"5px"}}>
                            Confirmar
                        </Button>
                        <Button variant="contained" onClick={handleClose} style={{margin:"5px"}}>
                            Cancelar
                        </Button>
                    </div>
                    <div style={{marginBottom:"200px"}}></div>

                </DialogContent>
            </form>
        </Dialog>);
}

const UpdateModal = formikEnhancer(MyForm);
export default UpdateModal;
